import React, { useState } from 'react'
import { useLocation, useParams } from 'react-router'
import rev from './rev.module.css'
import { LuFileSliders } from 'react-icons/lu';
import { MdOutlineDashboard } from 'react-icons/md';
import { CiSearch, CiSettings } from 'react-icons/ci';
import { RiArrowLeftDoubleFill } from 'react-icons/ri';
import imgi from '../../../img/img14.png'

const PublishReview = () => {
    const [Search, setSearch] = useState('')
  const { Spot } = useParams(); // Get the dynamic parameter from the URL
  const location = useLocation(); // Get the state from the previous page
  const source = location.state?.source || "Unknown"; // Check where the user came from

  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  let date = new Date();

  let n = date.toLocaleString([], {
     
      minute: "2-digit",
});

  return (
    <div >
      
          
      {source === "A" ? (
        <div className={rev.rev}>
             <div className={rev.container}>
             <h2>Content for: {Spot}</h2>
                <div className={rev.content}>
                
              <div className={rev.block}>
                    <div className={rev.blocki}>
                        <div className={rev.seci}>
                            <div className={rev.icon}>
                                <MdOutlineDashboard className={rev.word}  size={'1rem'} />
                                
                                <h3 className={rev.word}>Dashboard</h3>
                            </div>
                            <div className={rev.icon}>
                                <LuFileSliders className={rev.wordi} size={'1rem'}/>
                                <h3>Article Review</h3>
                            </div>
                        </div>
                        <div className={rev.seciI}>
                            <div className={rev.icon}>
                                <CiSettings className={rev.wordi} size={'1rem'}/>
                                <h3>Settings</h3>
                            </div>
                            <div className={rev.icon}>                               
                                <h3>Logout</h3>
                            </div>
                        </div>
                    </div>
                    <div className={rev.blockI}>
                    <div className={rev.blockii}>
                        <div className={rev.dash}>
                            <h4>Article <RiArrowLeftDoubleFill /> Review </h4>
                            <div className={rev.dashi}>
                                <input 
                                type="search" 
                                name="search" id="search" 
                                placeholder='Search for article'
                                onChange={(e)=> setSearch(e.target.value)}/>
                                <CiSearch />

                            </div>
                        </div>
                    </div>
                    <div className={rev.blockiii}>
                        <img src={imgi} alt="" />
                        <button className={rev.btn}>World news</button>
                        <h2>Transgender protest against Donald trump’s 
                        administration in Washington </h2>
                    </div>
                    <div className={rev.blockiv}>
                      <div className={rev.flex}>
                        <p>
                          Tech company Smart Applications International (Smart) unveiled its cutting-edge digital system earlier this month to improve healthcare 
                            services and streamline patient operations. Kenya-based Smart Applications International, commonly known as Smart, operates 
                            primarily from its headquarters in Nairobi. Established over two decades ago, the company has emerged as  a prominent ISO-
                            certified ICT provider, serving 12 African nations and connecting with over 8,000 healthcare providers. Smart specialises in delivering 
                            innovative technological solutions that enhance operational efficiency and improve healthcare access across the continent.
                            Esther Macharia, Head of Hospital Operations, expressed gratitude for the participation of over 250 healthcare facilities utilising Smart’s 
                            solutions. she noted that technology is crucial in improving customer service and operational efficiency. Macharia showcased innovations 
                            like MediSmart, adopted by over 5,000 facilities, and SmartHealth+, which enhances hospital management through workflow automation. 
                            These advancements support 18,460 patient visits daily, reflecting significant improvements in healthcare accessibility and outcomes.
                        </p>
                        <div className={rev.secI}>
                          <h3>Empowering healthcare access</h3>
                          <p>
                            The recent event in Nairobi, ‘Empowering Healthcare Access Through Patient-Centered Care,’ aimed to unite healthcare providers and 
                          industry leaders to advance transformative delivery methods and address challenges within Kenya’s healthcare sector.
                          </p>
                      
                      </div>
                      <div className={rev.secI}>
                          <h3>Commitment to collaboration</h3>
                          <p>
                              Group Managing Director Harrison Muiru highlighted the importance of partnerships in healthcare transformation. He stated, “We 
                              celebrate not only our shared successes but also the partnerships that continue to shape the future of healthcare in Kenya.
                              ” Muiru called for deeper collaboration among stakeholders to enhance patient-centred care across the region. Read also: Kwara 
                              government unveils plans to boost yo
                          </p>

                        </div>
                    </div>
                    <div className={rev.flexi}>
                      <div className={rev.box}>
                        <h4>Embedded link</h4>
                        <p>https://www.kwara.kenya.xyz</p>
                      </div>
                      <div className={rev.box}>
                        <h4>Author</h4>
                        <p>Adebsii Gbemileke</p>
                      </div>
                      <div className={rev.box}>
                        <h4>Duration</h4>
                        <p>{n}mins</p>
                      </div>
                    </div>
                 </div>
                 <div className={rev.blockv}>
                  <button onClick={toggleModal} className={rev.btnii}>Publish Article</button>
                  <button className={rev.btniii}>Decline Review</button>
                  {modal && (
                                <div className="modal">
                                    <div onClick={toggleModal} className={rev.overlay}></div>
                                        <div className={rev.modalcontent}>
                                            <h2>Article Successful</h2>
                                            <p>
                                            Article has been sent and is under review, please wait for the reviewer to access 
                                            and review your article. You will be notified when your 
                                            article is accepted
                                            </p>
                                
                                            <button className={rev.closemodal} onClick={toggleModal}>
                                                Go to Dashboard
                                            </button>
                                        </div>
                                </div>
                             )}
                 </div>
              </div>
            </div>
                </div>
             </div>
        </div> 
      ) : source === "B" ? (
        <div style={{ background: "#FFEBEE", padding: "10px", borderRadius: "8px" }}>
          <h2>Welcome from Page B</h2>
          <p>This is content specifically for visitors coming from **Page B**.</p>
          <p>The slug in the URL is: {Spot}</p>
        </div>
      ) : (
        <p>Unknown source. Please visit from Page A or Page B.</p>
      )}
    </div>
  )

}
export default PublishReview
